import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Base, Divider, Flex, Heading, Button, Text, } from '@stepstone-genesis/components';
import { Trans, useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector, useAppDispatch } from '../../redux/hooks.js';
import { LoginAlert } from '../AccountIdentifier/components/LoginAlert.js';
import { sendGlobalTrackingThunk } from '../../redux/core/thunks.js';
import { lastLoginMethodSelector } from '../../redux/core/authSuccess/authSuccessSlice.js';
import { hasSocialAuthConsent } from '../../redux/core/consent/consentSlice.js';
import { isAppleEnabledSelector, isFacebookEnabledSelector, isGoogleEnabledSelector, } from '../../redux/core/siteConfig/siteConfigSlice.js';
import { LinkedInCEExceptDELoginExperimentKey, LinkedInDELoginExperimentKey, LinkedInUKLoginExperimentKey, } from '../../redux/core/experiments/allExperiments/linkedInLogin.js';
import { useOptimizelyExperiment } from '../../redux/core/experiments/useOptimizelyExperiment.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { setActiveView, isFullscreenSelector, } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
import { SocialButtonWithWrapper } from '../../components/SocialsWrapper/index.js';
import { useMobile } from '../../helpers/hooks/index.js';
import { useTrack } from '../../tracking/common/hooks/useTrack.js';
import { trackLastLoginMethodVisibility } from '../../tracking/featureSpecific/lastLoginMethod/trackLastLoginMethodVisibility.js';
import { LoginWithEmailForm, LoginNegativeAlert } from '../../components/Login/index.js';
const TwoStepReturning = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const isMobile = useMobile();
    const isFullscreen = useAppSelector(isFullscreenSelector);
    const lastLoginMethod = useAppSelector(lastLoginMethodSelector);
    const hasSocialAuthConsentAccepted = useAppSelector(hasSocialAuthConsent);
    const linkedInDELoginExperimentVariant = useOptimizelyExperiment(LinkedInDELoginExperimentKey);
    const linkedInCEExceptDELoginExperimentVariant = useOptimizelyExperiment(LinkedInCEExceptDELoginExperimentKey);
    const linkedInUKLoginExperimentVariant = useOptimizelyExperiment(LinkedInUKLoginExperimentKey);
    const { trackBtnClick, trackModalComponentVisible } = useTrack('twoStep');
    const onCreateNewAccount = () => {
        dispatch(setActiveView(FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER));
        trackBtnClick({ uniqueName: 'createAnotherAccount' });
    };
    const isEmail = lastLoginMethod === 'email';
    const shouldShow = {
        apple: useAppSelector(isAppleEnabledSelector),
        google: useAppSelector(isGoogleEnabledSelector),
        facebook: useAppSelector(isFacebookEnabledSelector),
        linkedIn: linkedInDELoginExperimentVariant === 'B' ||
            linkedInCEExceptDELoginExperimentVariant === 'B' ||
            linkedInUKLoginExperimentVariant === 'B',
        email: isEmail,
    };
    const shouldShowReturningView = isFullscreen && //temporary until we get the green light on the login wall and inline version
        lastLoginMethod &&
        hasSocialAuthConsentAccepted &&
        shouldShow[lastLoginMethod];
    useEffect(() => {
        if (shouldShowReturningView) {
            trackModalComponentVisible(false);
            if (!isEmail) {
                dispatch(sendGlobalTrackingThunk(trackLastLoginMethodVisibility, {
                    lastLoginMethod,
                }));
            }
        }
    }, []);
    if (!shouldShowReturningView) {
        dispatch(setActiveView(FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER));
        return _jsx(_Fragment, {});
    }
    return (_jsxs(Flex, { flxDirection: 'column', gap: 'spaceXl', "data-testid": "two-step-returning", children: [_jsx(LoginAlert, {}), isMobile && (_jsx(Heading, { variant: "jumbo", textAlign: "center", children: t('loginregistration.fullscreenModalContent.returning.mobileHeader') })), !(isMobile && isEmail) && ( //this condition is temporary until we can introduce the soft login
            _jsx(Text, { variant: "large", fontWeight: "fontWeightBold", textAlign: "center", children: _jsx(Trans, { i18nKey: `loginregistration.fullscreenModalContent.returning.description.${lastLoginMethod}`, components: [
                        _jsx(Base, { as: isMobile ? 'br' : 'span', sx: { color: 'colorActionableDefault' } }, 0),
                    ] }) })), _jsxs(Flex, { flxJustify: 'center', flxDirection: 'column', gap: isEmail ? 'spaceL' : 'spaceXl', children: [isEmail ? (_jsxs(_Fragment, { children: [_jsx(LoginNegativeAlert, {}), _jsx(LoginWithEmailForm, { showPasswordless: true, buttonText: t('loginregistration.twoStepLoginRegistration.button.continue') })] })) : (_jsx(SocialButtonWithWrapper, { variant: lastLoginMethod ?? 'apple', buttonText: t(`loginregistration.fullscreenModalContent.returning.socialButton.${lastLoginMethod}`) })), _jsx(Divider, { py: "spaceM", children: t('loginregistration.fullscreenModalContent.returning.divider') }), _jsx(Button, { "data-testid": "two-step-returning-create-new", a11yLabel: "create-new-account", variant: "link", onClick: onCreateNewAccount, sx: {
                            lineHeight: 'lineHeightS',
                            fontFamily: 'fontFamilyBody',
                            fontSize: 'fontSizeM',
                            fontWeight: 'fontWeightNormal',
                        }, children: t('loginregistration.fullscreenModalContent.returning.newAccount') }, "create-new-account")] })] }));
};
export default TwoStepReturning;
//# sourceMappingURL=TwoStepReturning.js.map